import http from "../utils/http";

import config from "../config";
import { FormikValues } from "formik";

/**
 * Get all
 **/
const getAll = async () => {
  const url = `${config.baseUrl}${config.endPoints.department.getAll}`;
  return http.get(url);
};

const getById = async (id: string) => {
  const url = `${config.baseUrl}${config.endPoints.department.getById(id)}`;
  return http.get(url);
};

const create = async ( payload: FormikValues) => {
  const url = `${config.baseUrl}${config.endPoints.department.add}`;
  return http.post(url, payload);
};

const update = async (id: string, body: any) => {
  const url = `${config.baseUrl}${config.endPoints.department.update(id)}`;
  return http.put(url, body);
};

const deleteDistrict = async (id: string) => {
  const url = `${config.baseUrl}${config.endPoints.department.delete(id)}`;
  return http.delete(url);
};

const departmentService = {
  getAll,
  getById,
  create,
  update,
  deleteDistrict
};

export default departmentService;
